import { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../config/firebaseConfig';

export interface Branch {
  id: string;
  name: string;
  address: string;
  contactNumber?: string;
  mapUrl: string;
  order: number;
  isActive: boolean;
}

export const useBranches = () => {
  const [branches, setBranches] = useState<Branch[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        setLoading(true);
        const branchesRef = collection(db, 'branches');
        const q = query(branchesRef, orderBy('order', 'asc'));
        const querySnapshot = await getDocs(q);
        
        const branchesData: Branch[] = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          if (data.isActive !== false) { // Show all branches that are not explicitly inactive
            branchesData.push({
              id: doc.id,
              name: data.name,
              address: data.address,
              contactNumber: data.contactNumber,
              mapUrl: data.mapUrl,
              order: data.order || 0,
              isActive: data.isActive !== false
            });
          }
        });
        
        setBranches(branchesData);
        setError(null);
      } catch (err) {
        console.error('Error fetching branches:', err);
        setError('Failed to load branch information. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchBranches();
  }, []);

  return { branches, loading, error };
};
